import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";

export default function PendingRequests() {
  const [requests, setRequests] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const q = query(collection(db, "timeOffRequests"), where("status", "==", "pending"));
    const unsub = onSnapshot(q, (snap) => {
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setRequests(list);
    });
    return () => unsub();
  }, []);

  async function handleDecision(id, decision) {
    try {
      await updateDoc(doc(db, "timeOffRequests", id), { status: decision });
    } catch (err) {
      console.error("Error updating request:", err);
      alert("Failed to update request. Check permissions or Firestore rules.");
    }
  }

  return (
    <div className="relative mb-6">
      {/* Notification Bar */}
      <div className="flex items-center justify-between bg-gray-100 p-3 rounded shadow-sm border border-gray-200">
        <div className="flex items-center gap-3">
          <div className="relative">
            <button
              onClick={() => setOpen(!open)}
              className="relative focus:outline-none"
              aria-label="Toggle Requests"
            >
              <span className="text-2xl">🔔</span>
              {requests.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full px-1.5 py-0.5">
                  {requests.length}
                </span>
              )}
            </button>
          </div>
          <h2 className="text-lg font-semibold text-gray-800">
            Pending Requests
          </h2>
        </div>

        {requests.length === 0 && (
          <div className="text-sm text-gray-500 italic">No pending requests</div>
        )}
      </div>

      {/* Dropdown list */}
      {open && requests.length > 0 && (
        <div className="absolute mt-2 right-0 w-full max-w-2xl bg-white shadow-lg border border-gray-200 rounded-lg z-20">
          <div className="max-h-80 overflow-y-auto divide-y divide-gray-100">
            {requests.map((r) => (
              <div
                key={r.id}
                className="p-3 flex justify-between items-center hover:bg-gray-50 transition text-sm"
              >
                <div>
                  <div className="font-medium text-gray-800">{r.email}</div>
                  <div className="text-gray-600">
                    {r.date} ({r.start} - {r.end}) —{" "}
                    <span className="italic">{r.reason}</span>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleDecision(r.id, "approved")}
                    className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-xs"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleDecision(r.id, "denied")}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 text-xs"
                  >
                    Decline
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="p-2 text-center border-t border-gray-200 bg-gray-50 text-xs text-gray-500">
            Click outside to close
          </div>
        </div>
      )}
    </div>
  );
}
